import React from "react";
import { Router, Route, browserHistory, historyLocation } from "react-router";

import AuthMiddleware from "./middlewares/AuthMiddleware";
import ResetPasswordMiddleware from "./middlewares/ResetPasswordMiddleware";

import App from "./containers/App";
import Dashboard from "./containers/Dashboard";
import Login from "./containers/Login";
import Signup from "./containers/Signup";
import Main from "./containers/Main";
import EditUser from "./containers/EditUser";
import Report from "./containers/Report";
import ResetPassword from "./containers/ResetPassword";

export default store => {

	const authMiddleware = new AuthMiddleware(store); 
	const resetPasswordMiddleware = new ResetPasswordMiddleware();

	return (
		<Router history={browserHistory}>
			<Route component={App}>
				<Route path="/" component={Login} />
				<Route path="/cadastrar" component={Signup} />
				<Route component={Main} onEnter={authMiddleware.authorize} >
					<Route path="/dashboard" component={Dashboard} />
					<Route path="/password" component={EditUser} />
					<Route path="/report" component={Report} />
				</Route>
				<Route onEnter={resetPasswordMiddleware.validate} path="/reset-password" component={ResetPassword} />
			</Route>
			
		</Router>
	);
};


// WEBPACK FOOTER //
// src/routes.js